import { MSG_CAMPO_OBRIGATORIO } from 'utils/consts';

export const validarCaptcha = (captcha, handleValidade, setValidation, setValueCaptcha, onSendCaptcha) => {
  let postData = {
    userEnteredCaptchaCode: captcha.getUserEnteredCaptchaCode(),
    captchaId: captcha.getCaptchaId(),
  };

  if (postData.userEnteredCaptchaCode === '') {
    setValidation(MSG_CAMPO_OBRIGATORIO);
    if (handleValidade) handleValidade();
  } else {
    setValueCaptcha('');
    onSendCaptcha(postData);
  }
};
